import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=ecd72734&scoped=true&"
import script from "./classroom.vue?vue&type=script&lang=js&"
export * from "./classroom.vue?vue&type=script&lang=js&"
import style0 from "./classroom.vue?vue&type=style&index=0&id=ecd72734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd72734",
  null
  
)

export default component.exports